module.exports = __webpack_public_path__ + "static/images/mask.da05e487a24b9f50917df40809b6df4f.svg";